import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import Icon from "../Icon/Icon";
import Count from "./Count";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Pager = _ref => {
  let {
    id = "",
    className = "",
    style = {},
    countRight = false,
    disabled = false,
    hideCount = false,
    onNextClick,
    onPrevClick,
    paging: {
      current_page,
      next_page,
      prev_page,
      per,
      total_count
    }
  } = _ref;
  const prevBtnLabel = "Previous Page";
  const nextBtnLabel = "Next Page";
  const pagerContainerClass = () => cn("flex items-center", {
    "flex-row-reverse justify-start": countRight,
    "justify-end": !countRight
  }, className);
  const actionsClass = () => "flex flex-row ".concat(countRight ? 'mr-4' : 'ml-4');
  const nextBtnClass = () => cn("bg-white border h-10 w-10 outline-none rounded-r active:bg-field-border text-xs", {
    "bg-white cursor-default opacity-50": !next_page || disabled,
    "hover:bg-medium-fill-grey": next_page && !disabled
  });
  const prevBtnClass = () => cn("bg-white border h-10 w-10 outline-none rounded-l mr-[-1px] active:bg-field-border text-xs", {
    "bg-white cursor-default opacity-50": !prev_page || disabled,
    "hover:bg-medium-fill-grey": prev_page && !disabled
  });
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: pagerContainerClass(),
    style: style,
    children: [!hideCount && /*#__PURE__*/_jsx(Count, {
      currentPage: current_page,
      per: per,
      totalCount: total_count
    }), /*#__PURE__*/_jsxs("div", {
      className: actionsClass(),
      children: [/*#__PURE__*/_jsxs("button", {
        tabIndex: 0,
        className: prevBtnClass(),
        id: id,
        "aria-label": prevBtnLabel,
        disabled: !prev_page || disabled,
        onClick: onPrevClick,
        style: style,
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "ChevronArrow",
          direction: "left",
          size: 10
        }), /*#__PURE__*/_jsx("span", {
          className: "sr-only",
          children: "Previous Page"
        })]
      }), /*#__PURE__*/_jsxs("button", {
        tabIndex: 0,
        className: nextBtnClass(),
        id: id,
        "aria-label": nextBtnLabel,
        disabled: !next_page || disabled,
        onClick: onNextClick,
        style: style,
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "ChevronArrow",
          direction: "right",
          size: 10
        }), /*#__PURE__*/_jsx("span", {
          className: "sr-only",
          children: "Next Page"
        })]
      })]
    })]
  });
};
Pager.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** If true, pagination counter is on the right. */
  countRight: PropTypes.bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** If true, buttons are disabled. */
  disabled: PropTypes.bool.isRequired,
  /** If true, pagination counter is hidden. */
  hideCount: PropTypes.bool,
  /** Callback function when the next button is clicked */
  onNextClick: PropTypes.func.isRequired,
  /** Callback function when the previous button is clicked */
  onPrevClick: PropTypes.func.isRequired,
  /** paging object with paginatin information */
  paging: PropTypes.object.isRequired
};
export default Pager;
//# sourceMappingURL=Pager.js.map